import React, { useEffect, useRef, CSSProperties } from "react";
import { useFileObjectUrl } from "hooks/file";

const Image: React.FC<{
    id: string | undefined | null;
    alt?: string;
    height?: string;
    className?: string;
    setWidthImage?: (width: number) => void;
    setHeightImage?: (height: number) => void;
    setShowImageDefault?: (show: boolean) => void;
}> = ({ id, alt, height, className, setWidthImage, setHeightImage, setShowImageDefault }) => {
    const ref = useRef<HTMLImageElement | null>(null);
    const objectUrl = useFileObjectUrl(id, {
        onFetchError: () => setShowImageDefault?.(true),
    });

    let style: CSSProperties = {};
    if (height) {
        style.height = height;
    }

    useEffect(() => {
        if (!id) {
            setShowImageDefault?.(true);
        }
    }, [id, setShowImageDefault]);

    return (
        <React.Fragment>
            {id && objectUrl && (
                <img
                    src={objectUrl}
                    alt={alt ?? ""}
                    className={className}
                    style={style}
                    ref={ref}
                    onLoad={() => {
                        if (!ref.current) return;
                        setWidthImage?.(ref.current.naturalWidth);
                        setHeightImage?.(ref.current.naturalHeight);
                    }}
                />
            )}
        </React.Fragment>
    );
};

export default React.memo(Image);
